import api from "./api";

const EmployeePermissionService = {

  //  Get all screens
  getScreens: async () => {
    const res = await api.get("/employeePermission/screens");
    return res.data;
  },

  //  Get permissions by user
  getPermissionsByUser: async (userId) => {
    const res = await api.get(`/employeePermission/${userId}`);
    return res.data;
  },
  
    //  Get permissions by user
  getPermissionsByUserScreen: async (userId,screenId) => {
    const res = await api.get(`/employeePermission/${userId}/${screenId}`);
    return res.data;
  },

  //  Save permissions
  savePermissions: async (data) => {
    const res = await api.post("/employeePermission/save", data);
    return res.data;
  }

};

export default EmployeePermissionService;